import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Zap, Mail, Lock, Eye, EyeOff, ArrowRight, Building, Shield } from 'lucide-react';

export default function TenantLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    setTimeout(() => {
      if (email && password) {
        navigate('/tenant/dashboard');
      } else {
        setError('Please enter valid credentials');
      }
      setIsLoading(false);
    }, 1000);
  };

  return (
    <div className="tenant-login-page" data-testid="tenant-login-page">
      <div className="ambient-glow purple"></div>
      
      {/* Left Side - Branding */}
      <div className="login-branding tenant-branding">
        <div className="branding-content">
          <div className="logo-mark purple">
            <Zap size={40} />
          </div>
          <h1>Bolt Nexus</h1>
          <p className="tagline">Tenant Portal</p>
          
          <div className="feature-highlights">
            <div className="highlight-item">
              <Building size={24} />
              <div>
                <h4>Your Business Dashboard</h4>
                <p>Manage shipments, invoices, and customers</p>
              </div>
            </div>
            <div className="highlight-item">
              <Shield size={24} />
              <div>
                <h4>Secure & Isolated</h4>
                <p>Your data is protected with enterprise security</p>
              </div>
            </div>
          </div>

          <div className="powered-by">
            <span>Powered by</span>
            <div className="powered-logo">
              <Zap size={16} />
              <span>Bolt Nexus</span>
            </div>
          </div>
        </div>
      </div>

      {/* Right Side - Login Form */}
      <div className="login-form-container">
        <div className="login-card">
          <div className="login-header">
            <h2>Tenant Login</h2>
            <p>Access your courier business dashboard</p>
          </div>

          <form onSubmit={handleLogin} className="login-form">
            {error && (
              <div className="error-message" data-testid="login-error">
                {error}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <div className="input-wrapper">
                <Mail size={18} />
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@yourcompany.com"
                  required
                  data-testid="email-input"
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="input-wrapper">
                <Lock size={18} />
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  required
                  data-testid="password-input"
                />
                <button 
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                  data-testid="toggle-password"
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <div className="form-options">
              <label className="remember-me">
                <input type="checkbox" data-testid="remember-me" />
                <span>Remember me</span>
              </label>
              <a href="#" className="forgot-password">Forgot password?</a>
            </div>

            <button 
              type="submit" 
              className="btn btn-primary login-btn tenant-login-btn"
              disabled={isLoading}
              data-testid="login-submit"
            >
              {isLoading ? (
                <>Signing in...</>
              ) : (
                <>
                  Sign In <ArrowRight size={18} />
                </>
              )}
            </button>
          </form>

          <div className="login-footer">
            <p>Don't have an account? <a href="#">Contact Sales</a></p>
          </div>

          {/* Demo credentials hint */}
          <div className="demo-hint purple">
            <p>Demo: Enter any email and password to continue</p>
          </div>
        </div>
      </div>
    </div>
  );
}
